import FormatFunction from "../../../shared/utils/Fn";
import { SummaryEm, SummaryText } from "./index.styled";

interface TableFooterCountProps {
  total?: number;
  extra?: React.ReactNode;
}

/**
 * table footer 폼
 * @param param0
 * @returns
 */
export const TableFooterCount: React.FC<TableFooterCountProps> = ({
  total = 0,
  extra,
}) => {
  return (
    <SummaryText>
      총 <SummaryEm>{FormatFunction.numFormat(total || 0)}</SummaryEm>
      {extra && extra}
    </SummaryText>
  );
};
